<div class="frontpage-widget cover-image-trees-gray">
    <div class="whitebox dark-blue">
        <div class="container">
            <h2>Statistik</h2>
            <p>Statistikker for anvendelse af GrundRisk</p>
        </div>
    </div>
</div>

<div class="container">
    <div class="mt-5">
        <h4 *ngIf="isDisplayScreeningsAssessments" class="d-inline-block" i18n>Screeninger og risikovurdering per dag</h4>
        <div class="embed-responsive embed-responsive-16by9">
            <div id="screeningsAndAssessmentsReportContainer"  class="embed-responsive-item">Henter Statistik...</div>
        </div>
    </div>
</div>
<div class="container">
    <div class="mt-5">
        <h4 *ngIf="isDisplayLocationScreenings" class="d-inline-block" i18n>Seneste screeninger for Lokaliteter</h4>
        <div class="embed-responsive embed-responsive-16by9">
            <div id="locationScreeningsReportContainer"  class="embed-responsive-item">Henter Statistik...</div>
        </div>
    </div>
</div>

<div class="container">
    <div class="mt-5">
        <h4 *ngIf="isDisplayRiskCalculations" class="d-inline-block" i18n>Seneste risikoberegninger for Lokaliteter</h4>
        <div class="embed-responsive embed-responsive-16by9">
            <div id="riskCalculationsReportContainer"  class="embed-responsive-item">Henter Statistik...</div>
        </div>
    </div>
</div>

<br/>